module.exports = __webpack_public_path__ + "img/odos-xyz_logo.2fd90037.svg";